export default __webpack_public_path__ + "static/O0178-05c05819fcf2e0aa229b47e40afbb24d.png";